//URL global de las peticiones.
export const Global = {
    url: process.env.REACT_APP_API_URL,
}